import React from 'react'

interface IconToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  iconLeft: React.ReactNode
  iconRight: React.ReactNode
  labelLeft?: string
  labelRight?: string
}

export const IconToggle = ({ checked, onChange, iconLeft, iconRight, labelLeft, labelRight }: IconToggleProps) => {
  return (
    <div className="flex items-center gap-3">
      {labelLeft && <span className={`text-sm font-medium transition-colors ${!checked ? 'text-blue-600 font-semibold' : 'text-gray-400'}`}>{labelLeft}</span>}
      
      <button
        type="button"
        onClick={() => onChange(!checked)}
        className={`relative w-16 h-9 rounded-full transition-colors duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${checked ? 'bg-blue-600' : 'bg-gray-200'}`}
      >
        <div 
          className={`absolute top-1 left-1 bg-white w-7 h-7 rounded-full shadow-sm flex items-center justify-center transition-transform duration-300 ease-in-out ${checked ? 'translate-x-7' : 'translate-x-0'}`}
        >
          <div className={`transition-all duration-300 ${checked ? 'text-blue-600' : 'text-gray-500'}`}>
            {checked ? iconRight : iconLeft}
          </div>
        </div>
      </button>

      {labelRight && <span className={`text-sm font-medium transition-colors ${checked ? 'text-blue-600 font-semibold' : 'text-gray-400'}`}>{labelRight}</span>}
    </div>
  )
}
